import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';
import privateAxios from '../../utils/axios/privateAxios';
import publicAxios from '../../utils/axios/publicAxios';
import Notification from '../../components/Notification/Notification';
import './AdminEditGallery.css';

const AdminEditGallery = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [originalImageUrl, setOriginalImageUrl] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [display, setDisplay] = useState(false);

  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [notification, setNotification] = useState({ type: '', message: '' });

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => setNotification({ type: '', message: '' }), 5000);
  };

  // Fetch gallery item
  useEffect(() => {
    const fetchGallery = async () => {
      try {
        setLoading(true);
        const res = await privateAxios.get(`/private/fetch-admin-edit-gallery/${id}`);
        const { title, imageUrl, display } = res.data.image;

        setTitle(title);
        setImageUrl(imageUrl);
        setOriginalImageUrl(imageUrl);
        setDisplay(display);
      } catch (err) {
        console.error(err);
        showNotification('error', 'Failed to load gallery item.');
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, [id]);

  // Image change
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    setImageUrl(URL.createObjectURL(file));
  };

  // Upload image to S3
  const uploadImageToS3 = async () => {
    if (!imageFile) return originalImageUrl;

    const res = await privateAxios.get('/private/generate-upload-url', {
      params: {
        filename: imageFile.name,
        filetype: imageFile.type,
      },
    });

    const { url } = res.data;
    await publicAxios.put(url, imageFile);
    return url.split('?')[0];
  };

  // Update gallery
  const handleUpdate = async (e) => {
    e.preventDefault();
    setUpdating(true);

    try {
      const updatedImageUrl = imageFile
        ? await uploadImageToS3()
        : originalImageUrl;

      await privateAxios.patch(`/private/admin-edit-gallery/${id}`, {
        title,
        imageUrl: updatedImageUrl,
        display,
      });

      showNotification('success', 'Gallery updated successfully!');
      setTimeout(() => navigate('/admin-gallery'), 2000);
    } catch (err) {
      console.error(err);
      showNotification('error', 'Failed to update gallery.');
    } finally {
      setUpdating(false);
    }
  };

  return (
    <div className="admin-edit-gallery">
      <Notification {...notification} onClose={() => setNotification({ type: '', message: '' })} />

      <Link to="/admin-gallery">Back to Gallery</Link>

      <h2>Edit Gallery</h2>

      {loading ? (
        <Circles height="50" width="50" color="#008751" />
      ) : (
        <form onSubmit={handleUpdate} className='edit-form'>
          <label>Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />

          <div className='admin-edit-gallery-display-div'>
            <input
              // className='admin-edit-gallery-checkbox'
              type="checkbox"
              checked={display}
              onChange={(e) => setDisplay(e.target.checked)}
            />
            <label>Display publicly</label>
          </div>

          <label>Change Image (optional)</label>
          <input type="file" accept="image/*" onChange={handleImageChange} />

          {imageUrl && (
            <div className="image-preview">
              <img src={imageUrl} alt="Preview" />
            </div>
          )}

          <button type="submit" disabled={updating}>
            {updating ? 'Updating...' : 'Save Changes'}
          </button>
        </form>
      )}
    </div>
  );
};

export default AdminEditGallery;